import * as PopperJS from '@popperjs/core';
import classNames from 'classnames';
import React, { memo } from 'react';
import { Modifier, StrictModifierNames } from 'react-popper';

import customScrollStyles from '../CustomScroll/CustomScroll.styles.m.css';
import { Divider } from '../Divider/Divider';
import { TMenuItemSize } from '../MenuItem/MenuItem.types';
import { Popover } from '../Popover/Popover';
import { TUITheme } from '../types';
import styles from './PopoverMenu.styles.m.css';
import { IPopoverMenuItem } from './PopoverMenu.types';
import { isDivider } from './PopoverMenu.utils';
import { PopoverMenuItem } from './PopoverMenuItem/PopoverMenuItem';
import { PopoverSubMenu } from './PopoverSubMenu/PopoverSubMenu';

interface IPopoverMenuProps {
  className?: string;
  menuClassName?: string;
  onClose(): void;
  isOpened: boolean;
  isFullWidth?: boolean;
  menuItems: IPopoverMenuItem[];
  reference: HTMLElement | null;
  //  clickableReference - trigger element, which can contain reference element to relatively be positioned
  //  clickableReference is needed to avoid clickoutside handler in popover
  clickableReference?: HTMLElement | null;
  placement?: PopperJS.Placement;
  modifiers?: ReadonlyArray<Modifier<StrictModifierNames>>;
  theme?: TUITheme;
  size?: TMenuItemSize;
}

export const PopoverMenu = memo<IPopoverMenuProps>((props) => {
  const {
    className = '',
    menuClassName,
    onClose,
    isOpened,
    menuItems,
    reference,
    clickableReference,
    placement,
    modifiers,
    theme,
    size = 'small-1',
  } = props;

  const close = (): void => {
    onClose?.();
  };

  return (
    <Popover
      className={classNames(styles.container, customScrollStyles.container, className)}
      isOpened={isOpened}
      onClose={close}
      theme={theme}
      reference={reference}
      clickableReference={clickableReference}
      placement={placement}
      modifiers={modifiers}
    >
      {menuItems.map((item) => {
        if (isDivider(item)) {
          const dividerStyle = ['small-1', 'medium-1'].includes(size) ? 'style4' : 'style3';
          return (
            <Divider
              key={item.key}
              theme={item.theme || dividerStyle}
            />
          );
        }
        return item.items ? (
          <PopoverSubMenu
            key={item.key}
            onClose={onClose}
            item={item}
            theme={theme}
            menuItems={item.items}
            className={menuClassName}
            size={size}
          />
        ) : (
          <PopoverMenuItem
            key={item.key}
            onClose={close}
            item={item}
            className={menuClassName}
            theme={theme}
            size={size}
          >
            {item.children}
          </PopoverMenuItem>
        );
      })}
    </Popover>
  );
});
